/**
 * F17 — Pagina /ceilings.
 *
 * Layout snello (decisione 2026-05-22): solo lista delle stratigrafie ceiling
 * salvate dall'org + CTA "Nuovo controsoffitto" in header.
 *
 * Le 4 tipologie standard (CS-SUSP-DOUBLE / CS-SUSP-SINGLE / CS-FIX-SINGLE /
 * CS-FIRE) restano configurabili dal builder. Resta supportato il deep-link
 * `/ceilings/configurator?new=true&typology=<code>` per applicare la tipologia
 * direttamente (es. shortcut da PDF / chat).
 */
import React from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import AppSidebar from '@/components/layout/AppSidebar';
import Header from '@/components/layout/Header';
import PageContainer from '@/components/layout/PageContainer';
import BackButton from '@/components/layout/BackButton';
import { PanelTop, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import CeilingStratigraphyList from '@/components/configurator-v2/list-view/CeilingStratigraphyList';

const Ceilings: React.FC = () => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <SidebarInset className="flex flex-col">
          <Header />
          <PageContainer>
            <div className="mb-4">
              <BackButton />
            </div>
            <div className="mb-6 flex items-start justify-between gap-4 flex-wrap" data-tour-id="ceilings-page-header">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <PanelTop className="h-7 w-7 text-primary" />
                  <h1 className="text-3xl font-bold tracking-tight">Controsoffitti</h1>
                </div>
                <p className="text-muted-foreground">
                  Ricerca, modifica o crea un nuovo controsoffitto per la tua organizzazione.
                </p>
              </div>
              <Button asChild size="lg">
                <Link to="/ceilings/configurator?new=true">
                  <Plus className="h-4 w-4 mr-2" />
                  Nuovo controsoffitto
                </Link>
              </Button>
            </div>

            <CeilingStratigraphyList />
          </PageContainer>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default Ceilings;
